<template>
  <div class="device_power">
    <div class="power_box">
      <img src="@/assets/img/power.svg" class="power_icon" :class="{ 'no_power': data.power == 0 }" />
      <div class="power_bg" :class="{ 'no_power_bg': data.power == 0 }"
        :style="{ width: 32 * (data.power / 100) + 'px' }"></div>
      <img v-if="data.isCharging" src="@/assets/img/low_battery.svg" class="low_battery" />
    </div>
    <p class="power_num"
      v-if="specialCheckCurrent(speciaBehiver.WiredShowChargingAndPower) || !specialCheckCurrent(speciaBehiver.SpecialEquipment_WiredCharging)"
      :class="{ 'no_power_num': data.power == 0 }">
      {{ data.power || 0 }}%
    </p>

    <div class="device_power_massage" v-if="data.amberMouseGetPowerCount == 1 && data.power == 0">
      {{
        $t('power_message') }}</div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, toRef } from 'vue';
import { speciaBehiver, specialCheckCurrent } from '@/define/limit';
import { powerSet } from '@/service/driver/power_set';
const data = toRef(powerSet.state)
onMounted(() => {
  powerSet.getPowerData()
})
</script>

<style scoped lang="less">
.device_power {
  // display: flex;
  // align-items: center;
  cursor: pointer;

  &:hover {
    .device_power_massage {
      display: flex;
    }
  }

  .power_num {
    font-size: 14px;
    color: #FFF;
    margin-right: 6px;
    width: 100%;
    text-align: center;
  }

  .no_power_num {
    color: #FF3333;
  }

  .power_box {
    position: relative;
    display: flex;
    align-items: center;

    .power_icon {
      width: 46px;
      height: 24px;
    }

    .no_power {
      filter: brightness(0) saturate(100%) invert(33%) sepia(100%) saturate(7473%) hue-rotate(330deg) brightness(91%) contrast(107%);
    }

    .power_bg {
      position: absolute;
      background-color: #fff;
      width: 0px;
      height: 14px;
      left: 6px;
      border-radius: 2px;
    }

    .no_power_bg {
      background-color: #FF3333;
    }

    .low_battery {
      position: absolute;
      left: 19px;
    }
  }

  .device_power_massage {
    position: absolute;
    top: 30px;
    left: 30px;
    padding: 14px;
    color: #888888;
    font-size: 16px;
    text-wrap: nowrap;
    white-space: nowrap;
    display: none;
    background-color: #fff;
  }
}
</style>
